import { render } from "./ChatbottagArea.vue?vue&type=template&id=68fecd14&scoped=true"
import script from "./ChatbottagArea.vue?vue&type=script&lang=js"
export * from "./ChatbottagArea.vue?vue&type=script&lang=js"

import "./ChatbottagArea.vue?vue&type=style&index=0&id=68fecd14&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68fecd14"]])

export default __exports__